import { render, staticRenderFns } from "./OrderResults.vue?vue&type=template&id=39017b45"
import script from "./OrderResults.vue?vue&type=script&lang=js"
export * from "./OrderResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports